import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import ServicesSection from './components/ServicesSection';
import PortfolioGallery from './components/PortfolioGallery';
import OwnerStatement from './components/OwnerStatement';
import TestimonialsSlider from './components/TestimonialsSlider';
import ServiceAreas from './components/ServiceAreas';
import ContactForm from './components/ContactForm';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import { injectSchemaOrg } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    injectSchemaOrg();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroCarousel />
      <ServicesSection />
      <PortfolioGallery />
      <OwnerStatement />
      <TestimonialsSlider />
      <ServiceAreas />
      <ContactForm />
      <FinalCTA />
      <Footer />
    </div>
  );
}
